function initMarketingOpSearch() {
  const searchInput = document.querySelector('.search-bar .search-bar__input');
  searchInput.addEventListener("input", (e) => {
    if (e.target.value.includes(marketing.operation.launcher)) {
      const handle = marketing.operation.product;
      let langPrefix = '';
      if (marketing.operation.locale) {
        langPrefix = '/' + marketing.operation.locale;
      }
      const productMarketingUrl = `${langPrefix}/products/${handle}`;
      window.location.href = productMarketingUrl;
    }
  });
}
document.addEventListener('DOMContentLoaded', initMarketingOpSearch);